import {
  ProductGroupCreateMutationOptions,
  ProductGroupDeleteMutationOptions,
  ProductGroupUpdateMutationOptions,
  FuelProductGroupCreateMutationOptions,
  FuelProductGroupUpdateMutationOptions,
  useProductGroupCreateMutation,
  useProductGroupDeleteMutation,
  useProductGroupUpdateMutation,
  useFuelProductGroupCreateMutation,
  useFuelProductGroupUpdateMutation,
} from '@occc/graphql';

import { useMutation } from '../utils';

export const useProductGroupCreate = (baseOptions: ProductGroupCreateMutationOptions) =>
  useMutation(useProductGroupCreateMutation, baseOptions);

export const useUpdateProductGroup = (baseOptions: ProductGroupUpdateMutationOptions) =>
  useMutation(useProductGroupUpdateMutation, baseOptions);

export const useProductGroupDelete = (baseOptions: ProductGroupDeleteMutationOptions) =>
  useMutation(useProductGroupDeleteMutation, baseOptions);

export const useFuelProductGroupCreate = (baseOptions: FuelProductGroupCreateMutationOptions) =>
  useMutation(useFuelProductGroupCreateMutation, baseOptions);

export const useFuelProductGroupUpdate = (baseOptions: FuelProductGroupUpdateMutationOptions) =>
  useMutation(useFuelProductGroupUpdateMutation, baseOptions);
